import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-device-rd",
  "use": "icon-soc-l1-device-rd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-device-rd\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M192 256h448v512H192V256zm64 64v384h320V320H256z\" />\r\n  <path d=\"M704 192l128 128-64 64-48-48-96 96 48 48-64 64-128-128 64-64 48 48 96-96-48-48 64-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-device-rd.svg
// module id = A4qT
// module chunks = 477